(function () {
    'use strict';
    var m = angular.module('dashboard');
    m.factory('policyInfoBox', ["policyDao", "$timeout", "routeHelper", "policyInfoBoxesHelper", function (policyDao, $timeout, routeHelper, policyInfoBoxesHelper) {
        return function ($scope, logic) {
            var dataWatch = _.noop;
            var leftMessageText = '', rightMessageText = '';
            if (logic.settings.mode && logic.settings.mode !== 'policy' || logic.settings.policyId) {
                if (_(logic.settings.mode).isUndefined() && logic.settings.policyId) {
                    logic.settings.mode = 'policy';
                }
                var showTypeId = logic.settings.showType;
                var showType = _(logic.properties.showTypes).find(function (type) {
                    return type.id === showTypeId;
                });
                var period = _(logic.properties.periods).find(function (period) {
                    return period.id === logic.settings.period;
                });
                var showType2Id = logic.settings.showType2;
                var showType2 = _(logic.properties.showTypes).find(function (type) {
                    return type.id === showTypeId;
                });
                leftMessageText = logic.settings.valueTitle || '';
                dataWatch = $scope.$watch('model.data', function () {
                    if ($scope.model.data.policies.length === 0) {
                        if (logic.settings.rightMode !== 'value' || $scope.model.data.rightData.policies.length === 0) {
                            $scope.model.lines = [{
                                    'class': 'empty-infobox-area',
                                    text: '#' + JSON.stringify({
                                        display: 'text',
                                        text: 'No queries match the current configurations.'
                                    }) + '#' + JSON.stringify({
                                        display: 'text',
                                        text: 'Click here to configure.',
                                        'class': 'link-like',
                                        clickEvent: {
                                            name: 'configure-infobox',
                                            infoboxId: $scope.model.settings.id
                                        }
                                    })
                                }];
                            return;
                        }
                    }
                    var displayData = policyInfoBoxesHelper.makeDisplayData($scope.model.data, logic.settings, logic.version);
                    var mainCount = displayData.leftCount;
                    var rightCount = displayData.rightCount;
                    leftMessageText = displayData.leftMessageText;
                    rightMessageText = displayData.rightMessageText;
                    var leftCover = {
                        display: 'div',
                        'class': 'left-cover',
                        clickEvent: _.isArray(mainCount) ? mainCount[0].clickEvent : mainCount.clickEvent
                    };
                    var rightCover = {
                        display: 'div',
                        'class': 'right-cover',
                        clickEvent: (_.isArray(rightCount) ? rightCount[0].clickEvent : rightCount.clickEvent) || (_.isArray(mainCount) ? mainCount[0].clickEvent : mainCount.clickEvent)
                    };
                    $scope.model.dataLines = $.extend(true, $scope.model.dataLines || [], [
                        {
                            text: '#' + JSON.stringify({
                                display: 'text',
                                text: leftMessageText,
                                'class': 'message-left'
                            }) + '#' + JSON.stringify({
                                display: 'text',
                                text: rightMessageText,
                                'class': 'message-right'
                            })
                        },
                        { text: '#' + JSON.stringify(leftCover) },
                        { text: '#' + JSON.stringify(rightCover) },
                        { text: _.isArray(mainCount) ? '#' + JSON.stringify(mainCount[0]) + '#' + JSON.stringify(mainCount[1]) : '#' + JSON.stringify(mainCount) },
                        { text: _.isArray(rightCount) ? '#' + JSON.stringify(rightCount[0]) + '#' + JSON.stringify(rightCount[1]) : '#' + JSON.stringify(rightCount) }
                    ]);
                    $timeout(function () {
                        _($scope.model.dataLines).chain().last(2).each(function (line) {
                            line.class = line.class.split(' zero-opacity').join('');
                            if (logic.fontColors) {
                                line.style = { 'color': $scope.model.settings.conf.fontColor || '#80858c' };
                            }
                        });
                    });
                    $scope.model.lines = $scope.model.dataLines;
                });
            }
            if (!_($scope.model.dataLines).isArray()) {
                $scope.model.dataLines = [
                    {
                        'class': 'double-messages-line',
                        text: ''
                    },
                    {
                        'class': 'zero-opacity',
                        text: ''
                    },
                    {
                        'class': 'zero-opacity',
                        text: ''
                    },
                    {
                        text: '0',
                        'class': 'count zero-opacity'
                    },
                    {
                        text: '',
                        'class': 'count right zero-opacity infobox-trend-arrows uparrow-' + logic.settings.uparrow
                    }
                ];
            }
            $scope.model.lines = $scope.model.dataLines;
            var destroyOpenPolicy = $scope.$on('open-policy', function (event, data) {
                routeHelper.redirectTo('policy-edit', { id: data.id }, { qs: data.qs });
            });
            return function () {
                dataWatch();
                destroyOpenPolicy();
            };
        };
    }]);
}());